import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { ProjectTypesService } from '../../shared/services/project-types.service';
import { Profile } from 'src/app/models/Profile';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { environment } from 'src/environments/environment';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};

@Component({
  standalone: false,
  selector: 'app-parameterization-dialog',
  templateUrl: './parameterization-dialog.component.html',
  styleUrls: ['./parameterization-dialog.component.css'],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }],
})
export class ParameterizationDialogComponent implements OnInit {

  variables: any;

  //Temporary static items.
  items: any;

  local_data: any; //local data is the data that has been passed from the parent to this dialog and will be passed back to the parent.

  nameInvalidInput: boolean = false;
  effortInvalidInput: boolean = false;

  nameErrorMessage: string = '';
  effortErrorMessage: string = '';

  formGroup1: any;

  effort = '';

  otherTypeMacro = false;
  isActionType: boolean = false;

  riskInputEffort: any;
  isEdit = false;
  listInDB: any;
  profiles: Profile[] = [];
  centers: string[] = [];
  filteredProfiles: Profile[] = [];
  itemIndex: number = 0;

  constructor(private projectTypesService: ProjectTypesService,
    public dialogRef: MatDialogRef<ParameterizationDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private infoBar: InfoBarWithStatusService,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };

    //Add default values to predefined list
    this.listInDB = Array.isArray(this.local_data.listInDB) ? this.local_data.listInDB : [];
    this.profiles = Array.isArray(this.local_data.profiles) ? this.local_data.profiles : [];
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;

      this.effort = this.variables?.hours;
    });

    this.isEdit = this.local_data.isEdit
    this.itemIndex = this.local_data.itemIndex;

    this.formGroup1 = this._formBuilder.group({
      standardCtrl: [{ value: '' }, Validators.required],
      nameCtrl: [{ value: '' }, Validators.required],
      effortCtrl: ['', [Validators.required, Validators.min(0), Validators.max(environment.complexityMaxHours)]],
      centerCtrl: [''],
      profileCtrl: [''],
    });

    this.centers = [...new Set(this.profiles.map(p => p.center).filter(c => !!c))] as string[];
    this.filteredProfiles = this.profiles;

    if (this.isEdit) {
      this.formGroup1.get('effortCtrl')?.setValue(this.local_data.item.complexity);
      this.formGroup1.get('nameCtrl')?.setValue(this.local_data.item.name);
      this.formGroup1.get('profileCtrl')?.setValue(this.local_data.item.profileId || '');
      const existingProfile = this.profiles.find(p => p.id === this.local_data.item.profileId);
      if (existingProfile?.center) {
        this.formGroup1.get('centerCtrl')?.setValue(existingProfile.center);
        this.filteredProfiles = this.profiles.filter(p => p.center === existingProfile.center);
      } else {
        this.filteredProfiles = this.profiles;
      }
    }
    else {

      this.formGroup1.get('nameCtrl')?.setValue('');
      this.formGroup1.get('effortCtrl')?.setValue('');


    }
  }


  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;


    if ((formGroup.nameCtrl === '' || formGroup.nameCtrl === undefined)) {
      this.nameInvalidInput = true;
      this.nameErrorMessage = this.variables.insertName;
      valid = false;
    }

    if ((formGroup.effortCtrl < 0 || formGroup.effortCtrl > environment.complexityMaxHours || !formGroup.effortCtrl)) {
      this.effortInvalidInput = true;
      this.effortErrorMessage = this.variables.numberBetweenZeroAndMaxHours + environment.complexityMaxHours;
      valid = false;
    }

    this.listInDB.some((item: any, index: number) => {

      if (index != this.itemIndex) {
        if (item.name === formGroup.nameCtrl) {
          this.nameInvalidInput = true;
          this.nameErrorMessage = this.variables.alreadyExists;
          valid = false;
        }
        return;
      }
    });



    if (valid) {
      this.local_data.name = formGroup.nameCtrl;
      this.local_data.complexity = formGroup.effortCtrl.toFixed(2);
      this.local_data.profileId = formGroup.profileCtrl || null;

      this.dialogRef.close({ data: this.local_data });
    }
    else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 2000);
    }
  }

  onCenterChange(center: string): void {
    if (center) {
      this.filteredProfiles = this.profiles.filter(p => p.center === center);
    } else {
      this.filteredProfiles = this.profiles;
    }
    this.formGroup1.get('profileCtrl')?.setValue('');
  }
}
